<template>
 <h1>tags</h1>
</template>

<script>

export default {
	name: 'tags'
}

</script>
